// Npm modules
import { useState, FC, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
// Components
import GradientButton from "../login/components/GradientButton";
// Shared components
import GradientText from "../../shared/GradientText/GradientText";
import InputGradientext from "../../shared/GradientTextInput/GradientTextInput";

// Selectors
import { getLoading } from "../../../selectors";
// Constant
import { Images } from "../../../constants";
// Scss
import styles from "../login/Login.module.scss";
import VerificationCountdown from "./VerificationCountdown";

interface IVerifyEmailProps {
  email: string;
  resendTriggerHandler: () => void;
  loading: boolean;
  timerDuration: number;
  proceedActionHandler: (email: string, verificationCode: string) => void;
}

const VerifyEmail: FC<IVerifyEmailProps> = (props: IVerifyEmailProps) => {
  // local state
  const [email, setEmail] = useState(props.email ?? "");
  const [verificationCode, setVerificationCode] = useState("");

  // action dispatch function
  const dispatch = useDispatch();

  // selectors
  const [loading] = useSelector((store: any) => [getLoading(store)]);

  // location
  const location = useLocation();

  const {
    containerAnon,
    containerAnon__login,
    text,
    text__subheader,
    containerAnon__subheader,
    containerAnon__inputs,
    containerAnon__actions,
  } = styles;

  const handleVerifyEmail = (email: string) => {
    props.proceedActionHandler(email, verificationCode);
  };

  const isDisabled = () => {
    const regex = /^[0-9]*$/;
    if (!regex.test(verificationCode) || verificationCode.length !== 6) {
      return true;
    }
    return false;
  };

  return (
    <div className={containerAnon}>
      <div className={containerAnon__login} data-testid="login-containerAnon">
        <GradientText string={"Verify Your Email and get started!"} />

        <div className={containerAnon__subheader}>
          <h2 className={`${text} ${text__subheader}`}>
            <div
              style={{
                fontFamily: "Montserrat",
                lineHeight: "1.8rem",
                justifyContent: "flex-start",
              }}
            >
              <p style={{ marginTop: "15px" }}>
                <b>Ready to dive in?</b>
              </p>
              <p>
                To kick off your journey, we need to verify your email address.
                Keep an eye on your inbox for a 6-digit OTP (One-Time Passcode)
                sent to email address:
                <div style={{ display: "flex" }}>
                  <GradientText fontSize="14" string={email}></GradientText>
                  <span>
                    <img
                      src={Images.pencil}
                      className="icon"
                      alt="edit email icon"
                      onClick={() => window.location.reload()}
                      style={{ cursor: "pointer", marginLeft: "0.5rem" }}
                      title="Edit email"
                    />
                  </span>
                </div>
              </p>
              <p>
                Please allow up to 5 minutes for it to arrive. Thank you for
                your patience.
              </p>
            </div>
          </h2>
        </div>

        <div className={containerAnon__inputs}>
          <InputGradientext
            name={"verificationCode"}
            handleChange={(event: any) => {
              setVerificationCode(event.target.value);
            }}
            maxLength={6}
            placeholder={"XXXXXX"}
            propValues={{
              styles: {
                textAlign: "center",
              },
            }}
          />
        </div>

        <VerificationCountdown
          initialTime={props.timerDuration}
          resendTriggerHandler={props.resendTriggerHandler}
          loading={props.loading}
        />

        <div className={containerAnon__actions}>
          <GradientButton
            handleClick={() => handleVerifyEmail(email)}
            isLoading={loading}
            disabled={isDisabled()}
            testid={"login-button"}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(VerifyEmail);
